import { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router";
import { useAuth } from "@/store/auth";
import { useMaster } from "@/store/master";

/** 로그인 필수 구역. 첫 세션 확인이 끝나기 전에는 아무것도 그리지 않는다(깜빡임 방지) */
export function RequireAuth({ admin = false }: { admin?: boolean }) {
  const { user, ready } = useAuth();
  const loc = useLocation();
  const loadMaster = useMaster((s) => s.load);
  const loadedAt = useMaster((s) => s.loadedAt);

  useEffect(() => {
    if (user && !loadedAt) void loadMaster();
  }, [user, loadedAt, loadMaster]);

  if (!ready) return null;
  if (!user) return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname + loc.search)}`} replace />;
  if (admin && user.role !== "admin") return <Navigate to="/app" replace />;
  return <Outlet />;
}
